import { devToolsLocalStorageKey } from "./devToolsConfigAtom";

export const requestInstrumentationHeader = "X-JM-Instrument-Request";

export const isRequestInstrumentationEnabled = (): boolean => {
  try {
    const config = JSON.parse(localStorage.getItem(devToolsLocalStorageKey) ?? "null");
    return config?.requestInstrumentation?.enabled === true;
  } catch {
    return false;
  }
};
